import Vue from "vue";
import Vuex from "vuex";

import state from "./state";
import mutations from "./mutations";
import actions from "./actions";
import auth from "./modules/auth";
import dashboard from "./modules/dashboard";
import sites from "./modules/sites";
import campaigns from "./modules/campaigns";
import events from "./modules/events";
import stats from "./modules/stats";
import servers from "./modules/servers";
import users from "./modules/users";
import profile from "./modules/profile";

Vue.use(Vuex);

export default new Vuex.Store({
	state,
	mutations,
	actions,
	modules: {
		auth,
		dashboard,
		sites,
		campaigns,
		events,
		stats,
		servers,
		users,
		profile
	}
});
